// Platform-specific accent color so you can tell environments apart at a glance.
// Sets the --env-primary CSS variable once at startup; the admin header and the
// booking pages both read it. Production keeps the original purple unchanged.
//
//   localhost / 127.0.0.1   -> green  (local dev)
//   *test-randevu* (tdh1)    -> blue   (staging)
//   everything else (pdh1)   -> #7957d5 (production, original)

const PROD_COLOR = "#7957d5";
const LOCAL_COLOR = "#2e7d32"; // green
const STAGING_COLOR = "#1565c0"; // blue

export function envPrimaryColor(host) {
  var h = host || window.location.hostname || "";
  if (h === "localhost" || h === "127.0.0.1") {
    return LOCAL_COLOR;
  }
  if (h.indexOf("test-randevu") !== -1) {
    return STAGING_COLOR;
  }
  return PROD_COLOR;
}

export function applyEnvColor() {
  document.documentElement.style.setProperty("--env-primary", envPrimaryColor());
}



// WEBPACK FOOTER //
// ./src/utils/envColor.js